// extracted by mini-css-extract-plugin
export var backdropBlur = "_jt-0";
export var contentCard = "_jt-5";
export var frame = "_jt-2";
export var image = "_jt-4";
export var imagePane = "_jt-3";
export var modal = "_jt-1";